import React, { useEffect, useState } from "react";
import { getCandidateApprovalFlow } from "../services/apiService";

const PRIMARY = 'rgb(18, 76, 114)';

const CandidateApprovalFlow = ({ candidateId }) => {
  const [flow, setFlow] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (candidateId) loadApprovalFlow();
  }, [candidateId]);

  const loadApprovalFlow = async () => {
    try {
      setLoading(true);
      const data = await getCandidateApprovalFlow(candidateId);
      setFlow(data || []);
    } catch (error) {
      console.error("Failed to load candidate approval flow", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 p-4">
        <div className="w-5 h-5 rounded-full border-2 animate-spin" style={{ borderColor: 'rgba(18,76,114,0.15)', borderTopColor: PRIMARY }} />
        <span className="text-sm" style={{ color: 'rgba(18,76,114,0.5)' }}>Loading approval flow...</span>
      </div>
    );
  }

  if (!flow.length) return null;

  return (
    <div className="rounded-xl p-5 mb-2" style={{ backgroundColor: 'rgba(18,76,114,0.02)', border: '1px solid rgba(18,76,114,0.08)' }}>
      <div className="flex items-center gap-0 overflow-x-auto">
        {flow.map((step, index) => {
          const isApproved = step.approval_status === "Approved";
          const isRejected = step.approval_status === "Rejected" || step.approval_status === "Send Back";
          const isPending = !isApproved && !isRejected;
          const isCurrent = isPending && (index === 0 || flow[index - 1]?.approval_status === "Approved");
          const isLast = index === flow.length - 1;

          const circleColor = isApproved ? '#059669' : isRejected ? '#ef4444' : isCurrent ? '#d97706' : '#d1d5db';
          const textColor = isApproved ? '#059669' : isRejected ? '#ef4444' : isCurrent ? '#d97706' : '#9ca3af';

          return (
            <React.Fragment key={index}>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold" style={{ backgroundColor: circleColor, color: '#fff' }}>
                  {isApproved ? '✓' : isRejected ? '✗' : step.level_order}
                </div>
                <div>
                  <div className="text-sm font-semibold whitespace-nowrap" style={{ color: textColor }}>{step.level_name}</div>
                  <div className="text-xs whitespace-nowrap" style={{ color: '#6b7280' }}>
                    {(() => {
                      const name = step.approver_name || step.approverName || step.Approver_name || '';
                      if (isApproved) return name || 'Approved';
                      if (isRejected) return name || step.approval_status;
                      if (isCurrent) return name ? `⏳ ${name}` : '⏳ Pending';
                      return name || 'Waiting';
                    })()}
                  </div>
                </div>
              </div>
              {!isLast && (
                <div className="flex-shrink-0 w-8 h-0.5 mx-2 rounded" style={{ backgroundColor: isApproved ? '#059669' : '#e5e7eb' }} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default CandidateApprovalFlow;
